import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, theme } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import { ApplePay, useApplePayPaymentMethod } from '../ApplePay';

/**
 * This is a wrapper around the `ApplePay.SetAsDefaultButton`.
 * It adds a divider line with "Or enter card manually" below it.
 */
export const CreditCardFormApplePay = (props: CreditCardFormApplePayProps) => {
  const { onSetApplePayAsDefault } = props;

  const { isApplePayDefault, isApplePaySupported } = useApplePayPaymentMethod();
  const { t } = useLocalizationContext();
  const addManually = t('credit-card-form.add-card-manually');

  if (!isApplePaySupported || isApplePayDefault || !onSetApplePayAsDefault) {
    return null;
  }

  return (
    <View>
      <ApplePay.SetAsDefaultButton onPress={onSetApplePayAsDefault} />

      <View style={styles.dividerRow}>
        <View style={styles.dividerLine} />
        <BodyText style={styles.dividerTitle}>{addManually}</BodyText>
        <View style={styles.dividerLine} />
      </View>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  dividerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing['4'],
  },
  dividerTitle: {
    flex: 2,
    textAlign: 'center',
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: theme.colors.BLACK,
    marginHorizontal: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type CreditCardFormApplePayProps = {
  onSetApplePayAsDefault?: () => void;
};
